// Mapeamento puro de payload de push web -> rota de destino, consumido pelo
// listener de clique em notificationService.js. Extensível: adicionar um novo
// data.type no futuro é só um novo `case` aqui, sem tocar no SDK nem no router.
//
// Nenhum tipo de push web tem navegação hoje (o mérito pendente deixou de existir).

/**
 * @param {{ type?: string } | null | undefined} data
 * @returns {{ name: string } | null} nome de rota do vue-router, ou null se
 *   o tipo não for reconhecido (o listener não navega em silêncio).
 */
export function resolveWebNotificationRoute(data) {
  switch (data?.type) {
    default:
      return null
  }
}
